import { EXTERNAL_CONTEXT } from 'app/config/urls';
import { stipAxios } from '../axios';

const logOut = () => ({
    data: {},
});

const authEndpoints = {
    logIn: async (credentials) => {
        const { data } = await stipAxios.post('/user/login', credentials);
        return data;
    },
    getLoggedInUser: () => stipAxios.get('/user/me'),
    recoveryPassword: (email) => stipAxios.post('/user/login/services-portal/reset-password', email),
    resetPassword: ({ deCpfCnpj, deEmail }) => stipAxios.post(`/user/reset-password`, { deCpfCnpj, deEmail }),
    changePassword: (changeKey, password) =>
        stipAxios.post(`${EXTERNAL_CONTEXT}/usuario/change-password/${changeKey}`, { password }),
    logOut,
};

export default authEndpoints;
